import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

interface ValidatorOptions {
  field: string;
  condition?: boolean;
}

export function requiredWhenFieldIsNotNull(options: ValidatorOptions): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    if (!control || !control.root || !control.parent) {
      return null;
    }

    if (options.condition !== undefined && options.condition === false) {
      return null;
    }

    const fieldValue = control.root.get(options.field).value;

    if (
      fieldValue !== undefined &&
      fieldValue !== null &&
      fieldValue !== '' &&
      (control.value === undefined || control.value === null || control.value === '' || control.value.length === 0)
    ) {
      return { required: true };
    }

    return null;
  };
}
